export default {
  'meta': {
    'langName': 'TRADITIONAL CHINESE',
    'lang': '繁體中文'
  },
  'title': '產品維修 籃球框 B900 BOX NBA TARMAK',
  'description': '經內部檢測，我們發現當B900籃球架在未安裝高度調整把手的情況下進行使用或移動時，籃球桿存在潛在的傾倒風險。\n為了您的安心與安全，我們懇請您立即停止在未安裝高度調整把手時使用此產品。\n我們將為您免費提供一份專屬維修套件，透過一個簡單的步驟即可輕鬆加固您的產品，確保您未來能安全無虞地繼續使用。\n目前，我們正在建造一個專為此對此次產品維修的網站，它將提供詳細的步驟，協助您輕鬆完成所有操作。網站預計於七月期間上線，上線後我們將會第一時間通知您，請您放心。\n感謝您的理解與配合。',
  'status': 'Translation validated by COUNTRY'
} as const
